/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAgentSchedulesQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListAgentSchedulesQueryParamOrder = ClosedEnum<
  typeof ListAgentSchedulesQueryParamOrder
>;

export type ListAgentSchedulesRequest = {
  agentId: string;
  limit?: number | undefined;
  order?: ListAgentSchedulesQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListAgentSchedulesQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListAgentSchedulesQueryParamOrder
> = z.nativeEnum(ListAgentSchedulesQueryParamOrder);
/** @internal */
export const ListAgentSchedulesQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListAgentSchedulesQueryParamOrder
> = ListAgentSchedulesQueryParamOrder$inboundSchema;

/** @internal */
export const ListAgentSchedulesRequest$inboundSchema: z.ZodType<
  ListAgentSchedulesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentSchedulesQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListAgentSchedulesRequest$Outbound = {
  agent_id: string;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListAgentSchedulesRequest$outboundSchema: z.ZodType<
  ListAgentSchedulesRequest$Outbound,
  z.ZodTypeDef,
  ListAgentSchedulesRequest
> = z.object({
  agentId: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentSchedulesQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listAgentSchedulesRequestToJSON(
  listAgentSchedulesRequest: ListAgentSchedulesRequest,
): string {
  return JSON.stringify(
    ListAgentSchedulesRequest$outboundSchema.parse(listAgentSchedulesRequest),
  );
}
export function listAgentSchedulesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentSchedulesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentSchedulesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentSchedulesRequest' from JSON`,
  );
}
